<ng-container *ngIf="!showRelatedItems; else showRelatedItemCatalogComponentTemplate">
<div class="card w-full h-full flex flex-col shadow-sm p-6 rounded-2xl bg-white gap-6">
    <div class="flex flex-col gap-3">
      <div class="flex flex-col gap-2">
        <div class="w-full">

          <span class="font-semibold text-base md:text-2xl">Agregar productos al pedido</span>
        </div>
        <span
          class="text-xs md:text-sm">Explora nuestro catálogo y selecciona los productos que necesitas para tu pedido. </span>
      </div>
      <div class="flex flex-row flex-wrap justify-start gap-4">
        <app-custom-input
          [(value)]="product"
          placeholder="Ingresa el nombre del producto..."
          (enter)="onPageChange({ page: 0, first: 0, rows: rows })">
        </app-custom-input>
        <app-button
          label="Buscar"
          (clickButton)="onPageChange({ page: 0, first: 0, rows: rows })"
          [disabled]="product.length < 3">
        </app-button>
        <app-button label="Limpiar" color="red-500" icon="fi-rr-eraser" (click)="cleanFilter()"></app-button>
      </div>
      <div class="flex overflow-x-auto scroll-smooth scrollbar-hide gap-2">
        @for (category of categories; track category) {
          <button
            (click)="selectCategory(category)"
            [ngClass]="{'font-semibold border-b-2 border-orange-500': selectedCategory === category,
          'font-medium text-secondary-100': selectedCategory !== category
          }"
            class="flex-none px-4 py-2 cursor-pointer text-xs md:text-sm transition-all duration-150"
          >
            {{ category }}
          </button>
        }
      </div>
    </div>
    @if (productList && productList.length > 0) {
      <div class="card">
        <p-table
          #customTable
          [value]="[{}]"
          [paginator]="true"
          [rows]="rows"
          [first]="first"
          [lazy]="true"
          [lazyLoadOnInit]="false"
          (onLazyLoad)="loadProducts($event)"
          [totalRecords]="totalItems"
        >
          <ng-template pTemplate="body" let-product>
            <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 p-4">
              @for (product of productList; track product) {
                <div  (click)="openProductDetailDialog(product)"
                      class="flex flex-col  border-gray-chateau-100  p-4 gap-4 rounded-2xl  bg-white hover:bg-gray-100 shadow-[0_4px_8px_0_#00000029] cursor-pointer justify-between">
                  <div class="rounded-2xl flex flex-col justify-center items-center">
                    <img
                      [src]="product.images?.[0]?.url || 'asset/imagen-no-disponible-1.jpg'"
                      width="80"
                      height="80"
                      alt="{{ product.productType + product.finish  }}"
                      class="opacity-80 rounded-lg"
                    />
                  </div>
                  <div class="flex flex-row gap-4 justify-between">
                    <div class="flex flex-col gap-0.5">
                      <span class="font-semibold text-sm">{{ product.name }}</span>
                    </div>
                  </div>
                </div>
              }
            </div>
          </ng-template>
        </p-table>
      </div>
    } @else {
      <div class="bg-yellow-100 p-4 rounded-2xl">
        No hay registros
      </div>
    }
  </div>
</ng-container>

<ng-template #showRelatedItemCatalogComponentTemplate>
  <app-related-items></app-related-items>
</ng-template>
